// extracted by mini-css-extract-plugin
export var base = "notification-container-module--base--5d28f";